'use strict';
import { CriteriaColumn } from "./CriteriaColumn";
import { DevStackOrderDirection, DevStackOrder } from "./DevStackOrder";

// -----------------------------------------------------------------------------------
/** DevStackCriterion type  */
export var DevStackCriterion = {
    SIMPLE: "simple",
    LOGICAL: "logical"
};
// -----------------------------------------------------------------------------------
/** DevStackSelectable type  */
export var DevStackSelectable = {
    COLUMN: "column",
    FUNCTION: "function",
    FUNCTION_COALESCE: "coalesce",
    FUNCTION_CONCAT: "concat",

    /** Create a selectable */
    create: function (selectable) {
        // If selectable is column name, create column object
        if (angular.isString(selectable))
            return new CriteriaColumn(selectable);

        // Return selectable object
        return selectable;
    }
};

// -----------------------------------------------------------------------------------
/**
 * Criteria object
 * @constructor
 */
export var DevStackCriteria = function () {

    /** Entity name */
    this.entityName = null;

    /** List criterions */
    this.listSelect = [];

    /** List criterions */
    this.listCriterion = [];

    /** List groupBy */
    this.listGroupBy = [];

    /** List Having */
    this.listHaving = [];

    /** List order */
    this.listOrder = [];

    // -----------------------------------------------------------------------------------

    /**
     * Get, if defined, SimpleCriterion for column definition. If Column is in a complex Criterion (with Logical criterion) then no criterion
     * will be found
     *
     * @param column
     *            column definition
     * @return Criterion
     */
    this.getCriterion = function (column) {

        for (var criterion in this.listCriterion) {
            // Handle only simple criterion
            if (criterion.type == DevStackCriterion.SIMPLE)
                if (criterion.column == column)
                    return criterion;
        }

        return null;
    }

    /**
     * Remove criterion from column. Work only with a SimpleCriterion.
     *
     * @param column
     *            Column
     * @return Criterion removed
     */
    this.removeCriterion = function (column) {
        var removedCriterion = null;

        for (var i = 0; i < this.listCriterion.length; i++) {
            var criterion = this.listCriterion[i];
            // Handle only simple criterion
            if (criterion.type == DevStackCriterion.SIMPLE) {
                if (criterion.column.type == DevStackSelectable.COLUMN && criterion.column.name == column) {
                    this.listCriterion.splice(i, 1);
                    removedCriterion = criterion;
                }
            }
        }

        return removedCriterion;
    }

    // -----------------------------------------------------------------------
    // Orders columns
    // -----------------------------------------------------------------------

    /**
     * Add column order DESC
     *
     * @param column
     *            column to sort
     */
    this.addOrderByDesc = function (column) {
        this.addOrder(column, DevStackOrderDirection.DESC);
    }

    /**
     * Add column order ASC
     *
     * @param column
     *            Column
     */
    this.addOrderByAsc = function (column) {
        this.addOrder(column, DevStackOrderDirection.ASC);
    }

    /**
     * Get order for a column. Return null if no order is set
     *
     * @param column
     *            column
     * @return DevStackOrder
     */
    this.getOrder = function (column) {
        for (var order in this.listOrder) {
            if (order.column == column) {
                return order;
            }
        }

        return null;
    }

    /**
     * Get number of ordered columns
     *
     * @return int
     */
    this.getOrderCount = function () {
        return this.listOrder.length;
    }

    /**
     * Remove order for column.
     *
     * @param column
     *            column
     * @return DevStackOrder removed
     */
    this.removeOrder = function (column) {

        for (var i = 0; i < this.listOrder.length; i++) {
            var order = this.listOrder[i];
            if (order.column == column) {
                this.listOrder.splice(i, 1);
                return order;
            }
        }

        return null;
    }

    /**
     * Remove all orders criterion
     *
     * @return List of removed orders
     */
    this.removeListOrder = function () {
        var listRemovedOrder = this.listOrder;
        this.listOrder = [];

        return listRemovedOrder;
    }

    /**
     * Get number of criterion
     */
    this.getCriteriaCount = function () {
        return this.listCriterion.length;
    }

    // -----------------------------------------------------------------------
    // Usefull methods
    // -----------------------------------------------------------------------

    /**
     * Indicate whether the column is used in the criteria as an restrictions or in an order.
     *
     * @param column
     *            column
     * @return boolean
     */
    this.isUsed = function (column) {
        return this.getCriterion(column) != null || this.getOrder(column) != null;
    }

    /**
     * Add a criterion
     *
     * @param criterion
     *            criterion
     * @return DevStackCriteria
     */
    this.add = function (criterion) {
        if (criterion == undefined || criterion == null) {
            return this;
        }

        // Add criterion to list
        this.listCriterion.push(criterion);

        return this;
    }

    /**
     * Add order
     *
     * @param column
     *            column
     * @param orderDirection
     *            order direction
     * @return DevStackCriteria
     */
    this.addOrder = function (column, orderDirection) {
        if (column == undefined) {
            return this;
        }

        // Add order to list
        this.listOrder.push(new DevStackOrder(column, orderDirection));

        return this;
    }

    /**
     * Add column selection
     *
     * @param columns
     * @return
     */
    this.addSelect = function () {
        if (arguments.length == 0)
            return this;

        for (var i = 0; i < arguments.length; i++) {
            this.listSelect.push(DevStackSelectable.create(arguments[i]));
        }

        return this;
    }

    /**
     * Add column group By
     *
     * @param columns
     * @return
     */
    this.addGroupBy = function () {
        if (arguments.length == 0)
            return this;

        for (var i = 0; i < arguments.length; i++) {
            this.listGroupBy.push(DevStackSelectable.create(arguments[i]));
        }

        return this;
    }

    /**
     * Add crition to having statement
     *
     * @param critrons
     * @return
     */
    this.addHaving = function () {
        if (arguments.length == 0)
            return this;

        for (var i = 0; i < arguments.length; i++) {
            this.listHaving.push(DevStackSelectable.create(arguments[i]));
        }

        return this;
    }

};

